export default __webpack_public_path__ + "static/media/telegram.04b360f1.svg";